import { createRoot } from 'react-dom/client';
import { ProfessionalAppProvider, SiteFooter } from '@certifyinc/react-common';

export function mountSiteFooter(mountNodeId: string) {
    const container = document.getElementById(mountNodeId);
    if (!container) return;
    const root = createRoot(container);
    root.render(
        <ProfessionalAppProvider unauthenticated>
            <SiteFooter />
        </ProfessionalAppProvider>
    );
}
